<template>
  <div class="el-tabs el-tabs--top el-tabs--border-card card">
    <div class="el-tabs__header is-top" v-if="warehouses.length">
      <div class="el-tabs__nav-wrap is-top">
        <div class="el-tabs__nav-scroll">
          <div role="tablist" class="el-tabs__nav is-top is-stretch" style="transform: translateX(0px);">
            <div class="el-tabs__item is-top" :class="rotationType === 'rotation' ? 'is-active' : ''"
              @click="rotationType = 'rotation'">
              Sammelbuchung erfassen
            </div>
            <div class="el-tabs__item is-top" :class="rotationType === 'groupBookings' ? 'is-active' : ''"
              @click="rotationType = 'groupBookings'">
              Sammelbuchungen
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="el-tabs__content">
      <div role="tabpanel" id="pane-Route" aria-labelledby="tab-Route" class="el-tab-pane">
        <transition name="el-fade-in-linear">
          <div v-if="rotationType === 'rotation'">
            <div class="d-flex justify-content-between">
              <h4 class="card-title">Sammelbuchung erfassen</h4>
              <div>
                <fg-input>
                  <l-checkbox v-model="scanmodus" @click="checkRequiredFields" @input="focusProduct">Scanmodus</l-checkbox>
                </fg-input>
              </div>
            </div>
            <form @submit.prevent="submit">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group has-label">
                    <label>Grund</label>
                    <multiselect v-model="cause" :options="causes" track-by="id" label="name" @input="causeSelected"
                      @select="stockRotation.cause_id ? valErrors['cause_id'] = '' : ''"
                      placeholder="Grund auswählen" />
                    <div class="text-danger invalid-feedback" style="display: block;" v-if="valErrors['cause_id']">
                      Grund muss ausgewählt werden.
                    </div>
                  </div>
                </div>


                <div :class="costCenters.length ? 'col-sm-6' : 'col-sm-6'" v-if="warehouses.length > 1">
                  <div class="form-group has-label">
                    <label>Lager</label>
                    <multiselect v-model="warehouse" :options="warehouses" track-by="id" label="short_name"
                        @select="stockRotation.warehouse_id ? valErrors['warehouse_id'] = '' : ''"
                      @input="warehouseSelected" placeholder="Lager auswählen" />
                    <div class="text-danger invalid-feedback" style="display: block;" v-if="valErrors['warehouse_id']">
                      Lager muss ausgewählt werden.
                    </div>
                  </div>
                </div>
                <div class="col-sm-6" v-if="costCenters.length">
                  <div class="form-group has-label">
                    <label>Kostenstelle</label>
                    <multiselect v-model="costCenter" :options="costCenters" track-by="id" label="name"
                      @input="costCenterSelected" placeholder="Kostenstelle auswählen" />
                  </div>
                </div>
              </div>
              <template v-if="scanmodus">
                <div class="form-group has-label" style="position: relative;;">
                  <label>Code</label>
                  <input ref="inputField" @keydown.enter.prevent="findProduct"
                  v-model="code"
                  class="form-control" id="product"
                  >
                  <i @click="code = null" v-if="code" style="position: absolute; top: 40px; right: 5px; cursor: pointer; color: red;" class="fa fa-solid fa-minus"></i>
                  <br>
                  <div v-if="showCamera && stockRotation.cause_id && stockRotation.warehouse_id" @click="handleCamera">
                    <button type="button" class="btn btn-fill btn-info"> Kamera öffnen</button>
                  </div>
                  <br>
                  <div class="text-danger invalid-feedback" style="display: block;"
                    v-if="codeError"
                  >
                    Kein/e Produkt/Box für diesen Barcode oder QrCode gefunden
                  </div>
                </div>


                <div v-if="showCamera && allowCamera">
                  <Modal :visible="showModal" @close="showModal = false" >
                    <StreamBarcodeReader style="width: 100%; height: 100%;" @decode="onScan" ></StreamBarcodeReader>
                     </Modal>
                </div>

              </template>
              <template>
                <div class="row" v-for="(item, index) in stockRotation.rows">


                  <div class="col-sm-6">
                    <fg-input label="Menge" type="number" v-model.number="item.quantity"
                      :error="valErrors['quantity'] ? valErrors['quantity'][0] : null" />

                  </div>
                  <div class="col-sm-6">
                    <div @click="removeRow(index)"
                      style="position: absolute; top: 0; right:15px; color: red; font-size: 26px; cursor: pointer;"
                      class="text-right">
                      -
                    </div>
                    <product-select :index="index" :value="item.product" @input="productSelected" :include-boxes="true"
                      :val-error="valErrors['product_id'] ? valErrors['product_id'][0] : ''" />
                  </div>
                </div>
                <div @click="addRow()" class="text-right">
                  <button type="button" class="btn btn-fill btn-info">+</button>

                </div>

              </template>
              <price-input :price="stockRotation.price"
                :label="cause.direction == -1 ? 'Verkaufspreis' : 'Einkaufspreis (netto)'"
                @input="stockRotation.price = $event" v-if="showPrice" />

              <div class="form-group has-label">
                <label>Freitext</label>
                <Editor v-model="stockRotation.sammelbuchung_free_text"
                  api-key="75rbn6zzzmflhpysdjlnasy2oma7dk2f0cxs85ary6ma5ga4" :init="editorConfig" />
              </div>
              <fg-input label="Notiz" type="text" v-model="stockRotation.notice" />
              <l-checkbox v-model="stockRotation.with_einkaufspreis">Drucken mit Einkaufspreis</l-checkbox>
              <l-checkbox v-model="stockRotation.with_verkaufspreis">Drucken mit Verkaufspreis</l-checkbox>
              <l-checkbox v-model="stockRotation.showCause">Drucken mit Grund</l-checkbox>

              <div style="display: flex; justify-content: space-between;">
                <button ref="erfassenButton" type="submit" class="btn btn-fill btn-info">Erfassen</button>
                <a @click.prevent="handleErfassenAndPrint" :href="`${downloadUrl}`" target="_blank"
                  class="btn btn-fill btn-info">Erfassen und PDF Drucken</a>

              </div>
            </form>
          </div>
          <div v-if="rotationType === 'groupBookings'">
            <l-checkbox v-model="print.with_einkaufspreis">Drucken mit Einkaufspreis</l-checkbox>
            <l-checkbox v-model="print.with_verkaufspreis">Drucken mit Verkaufspreis</l-checkbox>
            <l-checkbox v-model="print.showCause">Drucken mit Grund</l-checkbox>
            <input @input="getGroupedStockRotaitons"
                  v-model="search"
                  class="form-control"
                  placeholder="Nach Notiz suchen..."
                  >
            <table class="table table-striped table-bordered" style="margin-top: 0.75em;">
              <thead>
                <tr>
                  <th>Sammelbuchung Nr.</th>
                  <th>Notiz</th>
                  <th>Datum</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="stock in lastGroupedBookings">
                  <td>
                    {{ stock.sammelbuchung_id }}
                  </td>
                  <td>
                    {{ stock.notice }}
                  </td>
                  <td>
                    {{ formatDate(stock.created_at) }}
                  </td>
                  <td class="text-right">
                    <a :href="`${downloadUrlGrouped}?sammelbuchung_id=${stock.sammelbuchung_id}&with_einkaufspreis=${print.with_einkaufspreis}&with_verkaufspreis=${print.with_verkaufspreis}&show_cause=${print.showCause}`"
                      target="_blank" class="btn btn-fill btn-info"> <i class="fa fa-solid fa-print"></i></a>
                  </td>
                </tr>
              </tbody>
            </table>
            <l-pagination
              background
              layout="prev, pager, next"
              :per-page="perPageVar"
              :page-count="pageCount"
              :value="currentPage"
              @input="changePage"
              @changePerPage="changePerPage"
           />
          </div>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
import ProductSelect from './product-select'
import PriceInput from 'src/components/price-input'
import api from 'src/api'
import moment from 'moment'
import Editor from '@tinymce/tinymce-vue'
import { StreamBarcodeReader } from "vue-barcode-reader";
import Modal from 'src/components/Modal.vue'
import hasPagination from 'src/has-pagination'

export default {
  props: ['initProduct', 'initCauses'],
  mixins: [hasPagination],
  components: {
    ProductSelect,
    PriceInput,
    Editor,
    StreamBarcodeReader,
    Modal
  },
  data() {
    return {
      rotationType: 'rotation',
      currentPage: 1,
      perPageVar: 50,
      search: '',
      stockRotation: {
        product_id: null,
        quantity: 1,
        direction: 'in',
        warehouse_id: null,
        cause_id: null,
        cost_center_id: null,
        comment: '',
        price: '',
        rows: [
          { quantity: null, product: null, product_id: null, batch: null, serial_number: null, expiry_date: null, production_date: null }
        ],
        with_einkaufspreis: false,
        with_verkaufspreis: false,
        showCause: false,
        sammelbuchung_free_text: null,
        notice: null,
        batch: null,
        expiry_date: null,
        production_date: null
      },
      product: null,
      warehouse: null,
      cause: null,
      costCenter: null,
      products: [],
      warehouses: [],
      causes: [],
      costCenters: [],
      valErrors: [],
      scanmodus: false,
      code: '',
      codeError: false,
      codeErrorSound: new Audio('/static/beep.wav'),
      codeSuccesSound: new Audio('/static/success.wav'),
      type: 'product',
      box: null,
      ueberRotation: {
        product_id: null,
        quantity: 1,
        warehouse_from_id: this.$store.state.authUser.warehouse_id,
        warehouse_to_id: null,
        comment: ''
      },
      ueberRotations: [],
      productUeber: null,
      warehouseUeberFrom: this.$store.state.authUser.warehouse || null,
      warehouseUeberTo: null,
      valUeberErrors: [],
      warehousesUeberFrom: [],
      warehousesUeberTo: [],
      authUserWarehouse: this.$store.state.authUser.warehouse,
      isFrontdesk: this.$store.getters.isFrontdesk,
      lastBookedIds: [],
      lastGroupedBookings: [],
      print: {
        with_einkaufspreis: false,
        with_verkaufspreis: false,
        showCause: false
      },
      editorConfig: {
        height: 300,
        apiKey: 'e9hzyqvby9nbkc6mpwc66s78s7n6i2as0880cpz6lgysn2td',
        menubar: 'insert view format tools table help', // Exclude 'file' and 'edit'
        toolbar: 'undo redo | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
        menu: {
          view: { title: 'View', items: 'code preview' },
          format: { title: 'Format', items: 'bold italic underline strikethrough' },

        }
      },
      showCamera: false,
      allowCamera : false,
      user: {},
      showModal: false,
      gsObj: { gtin: null, batch: null, expiry_date: null, production_date: null, serial_number: null },
      isGS1: false
    }
  },
  watch: {
    initProduct(newProduct, oldProduct) {
      this.productSelected(newProduct)
      this.productUeberSelected(newProduct)
    },
    initCauses(newCauses, oldCauses) {
      // deselect cause if other direction
      if (this.cause && newCauses && newCauses.length > 0) {
        if (this.cause.direction !== newCauses[0].direction) {
          this.cause = null
          this.stockRotation.cause_id = null
        }
      }
      this.causes = newCauses
    }
  },
  computed: {
    showPrice() {
      const causeHasPrice = this.cause && this.cause.has_price
      // frontdesk must not see einkaufspreis
      if (this.isFrontdesk) {
        return causeHasPrice && this.cause.direction === -1
      }
      return causeHasPrice
    },
    downloadUrl() {
      return `${api}/stock_rotations/current/download?last_booked_ids=${this.lastBookedIds}&with_einkaufspreis=${this.stockRotation.with_einkaufspreis}&with_verkaufspreis=${this.stockRotation.with_verkaufspreis}&show_cause=${this.stockRotation.showCause}`
    },
    downloadUrlGrouped() {
      return `${api}/stock_rotations/grouped_booking/download`
    },
    beforeRouteUpdate (to, from, next) {
    if (to.query && to.query.page) {
      this.currentPage = +to.query.page
      this.getGroupedStockRotaitons().then(() => { next() })
    } else {
      this.currentPage = 1
      this.getGroupedStockRotaitons().then(() => { next() })
    }
  },
  },
  methods: {
    changePage (page) {
      this.currentPage = page
      this.getGroupedStockRotaitons()
    },
    changePerPage (perPage) {
      this.perPageVar = perPage
      this.getGroupedStockRotaitons()
    },
    onScan(result) {
    this.code = result
    this.findProductCode(result)
  },
  handleCamera() {
    this.allowCamera = true;
    this.showModal = true;
  },
  checkScreen() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return this.showCamera  = true
      } else {
        return  this.showCamera =  false
      }

    },
    formatDate(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    addRow() {
      this.stockRotation.rows.push({ quantity: null, product: null, product_id: null })
    },
    handleErfassenAndPrint(event) {
      if (this.stockRotation.rows[0].product) {
        event.preventDefault();

        this.$refs.erfassenButton.click();

        setTimeout(() => {
          window.location.href = this.downloadUrl;
        }, 1000);

      }
    },
    removeRow(index) {
      this.stockRotation.rows.splice(index, 1);
    },
    focusProduct() {
      if (this.scanmodus) {
        this.$nextTick(() => { document.getElementById('product').focus() })
      }
      this.checkScreen()
    },
    submit() {
      this.submitProduct()
    },
    async submitProduct() {
      await this.initCsrf()

      if (this.stockRotation.rows[0].product) {
        this.$http.post(`/group/stock_rotations/store`, this.stockRotation).then(({ data }) => {
          data.forEach(rotation => {
            this.lastBookedIds = [];
            this.lastBookedIds.push(rotation.id)
          });
          this.resetStockRotation()
          this.$notify({
            message: 'Die Lagerbewegung wurde erfolgreich erfasst.',
            type: 'success'
          })
          this.$emit('stockRotationsCreated', data)
          // this.focusProduct()
        }).catch(({ response }) => { this.valErrors = response.data.errors })
        this.getGroupedStockRotaitons();
      }
    },
    async submitBox() {
      await this.initCsrf()

      this.$http.post(`/boxes/${this.box}/stock_rotations`, this.stockRotation).then(({ data }) => {
        this.resetStockRotation()
        this.$notify({
          message: 'Die Lagerbewegungen wurde erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', data)
        this.focusProduct()
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    setStockRotationPrice(product, cause) {
      if (+cause.direction === -1) {
        this.stockRotation.price = product ? product.price : ''
      } else if (+cause.direction === 1) {
        this.stockRotation.price = product ? product.einkaufspreis : ''
      } else {
        this.stockRotation.price = ''
      }
    },
    productSelected({ product, index }) {
      const item = this.stockRotation.rows[index];
      item.product = product;
      if (product) {
        if (product.isBoxModel) {
          item.type = 'box';
          item.box = product.id;
        } else {
          item.type = 'product';
          item.product_id = product ? product.id : null;
          if (this.cause && this.cause.has_price) {
            this.setStockRotationPrice(product, this.cause);
          } else {
            item.price = '';
          }
        }
      }
    },
    warehouseSelected(warehouse) {
      this.stockRotation.warehouse_id = warehouse ? warehouse.id : null
    },
    causeSelected(cause) {
      this.stockRotation.cause_id = cause ? cause.id : null
      if (cause && cause.has_price && this.product) {
        this.setStockRotationPrice(this.product, cause)
      } else {
        this.stockRotation.price = ''
      }
    },
    getGroupedStockRotaitons() {
      this.$http.get(`/group/stock_rotations?page=${this.currentPage}&per_page=${this.perPageVar}&search=${this.search}`).then(({ data }) => {
        this.lastGroupedBookings = data.data
        this.pageCount = data.last_page
      })
    },
    costCenterSelected(costCenter) {
      this.stockRotation.cost_center_id = costCenter ? costCenter.id : null
    },
    resetStockRotation() {
      this.type = 'product'
      this.product = null
      this.box = null
      this.code = ''

      this.stockRotation.rows = [
        { quantity: null, product: null, product_id: null, batch: null, expiry_date: null, production_date: null, serial_number: null }
      ],
        this.stockRotation.sammelbuchung_free_text = '';
      this.valErrors = []
      this.gsObj = { gtin: null, batch: null, expiry_date: null, production_date: null, serial_number: null }
    },
    async findProduct(e) {
      this.codeError = false;
      this.isGS1 = false;
      const barcodeValue = e.target.value;

      const gs1Patterns = ['10', '17', '11', '21'];

      if (barcodeValue.startsWith('01')) {
        const gtin = barcodeValue.substring(2, 16);

        if (/^\d{14}$/.test(gtin)) {
          const remainingData = barcodeValue.substring(16);

          if (gs1Patterns.some(pattern => remainingData.startsWith(pattern))) {
            this.isGS1 = true;
          }
        }
      }

      if (this.isGS1) {
        try {
          const { data } = await this.$http.get(`/product/decode/${barcodeValue}`);
          this.identifiers = data.identifiers;
        } catch (error) {
          console.error("Error fetching identifiers:", error);
          this.codeError = true;
          throw error;
        }

        Object.entries(this.identifiers).forEach(([key, item]) => {
          if (key === "01") this.gsObj.gtin = item.content;
          if (key === "10") this.gsObj.batch = item.content;
          if (key === "17") this.gsObj.expiry_date = item.raw_content;
          if (key === "11") this.gsObj.production_date = item.raw_content;
          if (key === "21") this.gsObj.serial_number = item.raw_content;
        });

        e.target.value = this.gsObj.gtin;
      }


      this.$http.get(`/products/code/${encodeURIComponent(e.target.value)}`).then(({ data }) => {
        if (data.type === 'product') {
          this.type = 'product';
          const existingRow = this.stockRotation.rows.find(row => row.product && row.product.id === data.product.id);
          if (existingRow) {
            existingRow.product = data.product;
            existingRow.product_id = data.product.id;
            existingRow.quantity += 1
          } else {
            if (this.stockRotation.rows[0].product) {

              if (this.isGS1) {
            data.product.barcode_type = 'gs1-128'
            this.$http.put(`/products/${data.product.id}`, data.product).then(({ data }) => { })

                this.stockRotation.rows.push({ quantity: 1, product: data.product, product_id: data.product.id, batch: this.gsObj.batch, expiry_date: this.gsObj.expiry_date, production_date: this.gsObj.production_date, serial_number: this.gsObj.serial_number });
              } else {
                this.stockRotation.rows.push({ quantity: 1, product: data.product, product_id: data.product.id });
              }

            } else {
              if (this.isGS1) {
                data.product.barcode_type = 'gs1-128'
                this.$http.put(`/products/${data.product.id}`, data.product).then(({ data }) => { })
                this.stockRotation.rows[0].product = data.product;
                this.stockRotation.rows[0].product_id = data.product.id;
                this.stockRotation.rows[0].quantity = 1;
                this.stockRotation.rows[0].batch = this.gsObj.batch;
                this.stockRotation.rows[0].expiry_date = this.gsObj.expiry_date;
                this.stockRotation.rows[0].production_date = this.gsObj.production_date;
                this.stockRotation.rows[0].serial_number = this.gsObj.serial_number;
              }else {
                this.stockRotation.rows[0].product = data.product;
                this.stockRotation.rows[0].product_id = data.product.id;
                this.stockRotation.rows[0].quantity = 1;

              }

            }
          }
        } else {
          this.type = 'box';
          this.box = data.box.id;
          this.submitBox();
        }
        this.$nextTick(() => {
          this.code = null;
          this.$refs.inputField.focus();
        });
      }).catch(({ response }) => {
        this.codeError = true;

       this.codeErrorSound.play()
      });
    },

    async findProductCode(code) {
      this.codeError = false;
      this.isGS1 = false;
      const barcodeValue = e.target.value;

      const gs1Patterns = ['10', '17', '11', '21'];

      if (barcodeValue.startsWith('01')) {
        const gtin = barcodeValue.substring(2, 16);

        if (/^\d{14}$/.test(gtin)) {
          const remainingData = barcodeValue.substring(16);

          if (gs1Patterns.some(pattern => remainingData.startsWith(pattern))) {
            this.isGS1 = true;
          }
        }
      }

      if (this.isGS1) {
        try {
          const { data } = await this.$http.get(`/product/decode/${barcodeValue}`);
          this.identifiers = data.identifiers;
        } catch (error) {
          console.error("Error fetching identifiers:", error);
          this.codeError = true;
          throw error;
        }

        Object.entries(this.identifiers).forEach(([key, item]) => {
          if (key === "01") this.gsObj.gtin = item.content;
          if (key === "10") this.gsObj.batch = item.content;
          if (key === "17") this.gsObj.expiry_date = item.raw_content;
          if (key === "11") this.gsObj.production_date = item.raw_content;
          if (key === "21") this.gsObj.serial_number = item.raw_content;
        });

        e.target.value = this.gsObj.gtin;
      }

      this.$http.get(`/products/code/${code}`).then(({ data }) => {
        if (data.type === 'product') {
          this.type = 'product';
          const existingRow = this.stockRotation.rows.find(row => row.product && row.product.id === data.product.id);
          if (existingRow) {
            existingRow.product = data.product;
            existingRow.product_id = data.product.id;
            existingRow.quantity += 1
            if(this.isGS1) {

              existingRow.batch = this.gsObj.batch;
              existingRow.expiry_date = this.gsObj.expiry_date;
              existingRow.production_date = this.gsObj.production_date;
            }
          } else {
            if (this.stockRotation.rows[0].product) {

              if (this.isGS1) {
                data.product.barcode_type = 'gs1-128'
                this.$http.put(`/products/${data.product.id}`, data.product).then(({ data }) => { })
                this.stockRotation.rows.push({ quantity: 1, product: data.product, product_id: data.product.id, batch: this.gsObj.batch, expiry_date: this.gsObj.expiry_date, production_date: this.gsObj.production_date, serial_number: this.gsObj.serial_number });
              } else {
                this.stockRotation.rows.push({ quantity: 1, product: data.product, product_id: data.product.id });
              }

            } else {
              if (this.isGS1) {
                data.product.barcode_type = 'gs1-128'
                this.$http.put(`/products/${data.product.id}`, data.product).then(({ data }) => { })
                this.stockRotation.rows[0].product = data.product;
                this.stockRotation.rows[0].product_id = data.product.id;
                this.stockRotation.rows[0].quantity = 1;
                this.stockRotation.rows[0].batch = this.gsObj.batch;
                this.stockRotation.rows[0].expiry_date = this.gsObj.expiry_date;
                this.stockRotation.rows[0].production_date = this.gsObj.production_date;
                this.stockRotation.rows[0].serial_number = this.gsObj.serial_number;
              }else {
                this.stockRotation.rows[0].product = data.product;
                this.stockRotation.rows[0].product_id = data.product.id;
                this.stockRotation.rows[0].quantity = 1;

              }

            }
          }
        }  else {
          this.type = 'box';
          this.box = data.box.id;
          this.submitBox();
        }
        this.allowCamera = false;
        this.user.enable_sound  ?  this.codeSuccesSound.play() : '';
        this.showModal = false;
        this.$nextTick(() => {
          this.code = null;
          this.$refs.inputField.focus();
        });

      }).catch(({ response }) => {
        this.codeError = true;
        this.codeErrorSound.play()
      });
    },

    productUeberSelected(product) {
      this.productUeber = product
      if (product) {
        if (product.isBoxModel) {
          this.ueberType = 'box'
        } else {
          this.ueberType = 'product'
        }
        this.ueberRotation.product_id = product ? product.id : null
      }
    },
    warehouseUeberFromSelected(warehouse) {
      this.ueberRotation.warehouse_from_id = warehouse ? warehouse.id : null
      // if (warehouse) {
      //   this.warehousesUeberTo = this.warehouses.filter(wh => warehouse.id !== wh.id)
      // } else {
      //   this.warehousesUeberTo = []
      //   this.ueberRotation.warehouse_to_id = null
      //   this.warehouseUeberTo = null
      // }
    },
    warehouseUeberToSelected(warehouse) {
      this.ueberRotation.warehouse_to_id = warehouse ? warehouse.id : null
    },
    async submitUeber() {
      this.addUeber()

      await this.initCsrf()
      this.$http.post(`/stock_rotations/ueber`, {
        warehouse_from_id: this.ueberRotation.warehouse_from_id,
        warehouse_to_id: this.ueberRotation.warehouse_to_id,
        products: this.ueberRotations,
        comment: this.ueberRotation.comment
      }).then(({ data }) => {
        this.productUeber = null
        this.ueberRotation.product_id = ''
        this.ueberRotation.comment = ''
        this.ueberRotation.quantity = 1
        this.ueberRotations = []
        this.valErrors = []
        this.$notify({
          message: 'Die Lagerübertragungen wurden erfolgreich erfasst.',
          type: 'success'
        })
        this.$emit('stockRotationsCreated', ...data)
      }).catch(({ response }) => { this.valUeberErrors = response.data.errors })
    },
    addUeber() {
      if (this.productUeber && this.ueberRotation.quantity) {
        const type = this.productUeber.isBoxModel ? 'box' : 'product'
        const index = this.findUeberProduct(this.ueberRotation.product_id, type)
        if (index >= 0) {
          this.ueberRotations[index].quantity += this.ueberRotation.quantity
        } else {
          this.ueberRotations.push({
            name: this.productUeber.name,
            product_id: this.ueberRotation.product_id,
            quantity: this.ueberRotation.quantity,
            type
          })
        }
        this.productUeber = null
        this.ueberRotation.product_id = ''
        this.ueberRotation.quantity = 1
      }
    },
    deleteUeber(ueber) {
      this.ueberRotations.splice(this.findUeberProduct(ueber.product_id, ueber.type), 1)
    },
    findUeberProduct(id, type) {
      return this.ueberRotations.findIndex(rot => (rot.product_id === id && rot.type === type))
    },
    setUserWarehouse(warehouseToSet, warehouseSelected) {
      this[warehouseToSet] = this.authUserWarehouse
      warehouseSelected(this.authUserWarehouse)
    },
    switchWarehouses() {
      const from = this.warehouseUeberFrom
      const to = this.warehouseUeberTo
      this.warehouseUeberFrom = to
      this.warehouseUeberFromSelected(to)
      this.warehouseUeberTo = from
      this.warehouseUeberToSelected(from)
    },
    checkRequiredFields() {

      this.checkScreen()
      if (!this.stockRotation.cause_id) {
        this.valErrors['cause_id'] = "Grund muss ausgefüllt werden"
        this.showCamera = false;
      } else {
        this.valErrors['cause_id'] = '';
      }
      if (!this.stockRotation.warehouse_id) {
        this.valErrors['warehouse_id'] = "Grund muss ausgefüllt werden"
        this.showCamera = false;
      } else {
        this.showCamera = true;
        this.valErrors['warehouse_id'] = '';
      }
},
  },
  created() {

    if (!this.initCauses) {
      this.$http.get(`/causes?only_selectable=1`).then(({ data }) => {
        this.causes = data
      })
    }
    this.checkScreen()
    this.$http.get(`/cost_centers`).then(({ data }) => {
      this.costCenters = data
    })
    this.getGroupedStockRotaitons();
    this.$http.get(`/users/${this.$store.state.authUser.id}`).then(({ data }) => { this.user = data
    })

    this.$http.get(`/warehouses`).then(({ data }) => {
      if (data.length === 1) {
        this.stockRotation.warehouse_id = data[0].id
      } else {
        this.stockRotation.warehouse_id = this.$store.state.authUser.warehouse_id
        this.warehouse = this.$store.state.authUser.warehouse
      }
      this.warehouses = data
    })
  }
}
</script>

<style scoped>
</style>
